import { Grid, makeStyles } from '@material-ui/core'
import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'

const useStyles = makeStyles(theme => ({
  root: {
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '100%',
    padding: 15,
    paddingBottom: 0,

    [theme.breakpoints.up('lg')]: {
      padding: 25,
      paddingBottom: 0
    }
  },
  dataContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  scoreItem: {
    marginLeft: 10,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  skeletonCircle: {
    borderRadius: '50%',
    width: 30,
    height: 30,
    marginBottom: 10
  },
  skeletonText: {
    width: 18,
    height: 30,
    marginLeft: 5,
    marginBottom: 10
  },
  barContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  skeletonBar: {
    width: '80%',
    height: 30,
    borderRadius: 15
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '60%'
  },
  descriptionContainer: {
    width: '90%'
  },
  description: {
    width: '90%',
    height: 15,
    marginTop: 20
  },
  shortDescription: {
    width: '60%',
    height: 15,
    marginTop: 20
  }
}))

const EngagementWidgetSkeleton = () => {
  const classes = useStyles()

  return (
    <Grid container direction="column" className={classes.root}>
      <Grid item className={classes.titleContainer}>
        <Skeleton variant="text" width="60%" height={30} />
      </Grid>
      <Grid container className={classes.dataContainer} item>
        {[1, 2, 3].map(index => (
          <Grid key={index} item className={classes.scoreItem}>
            <Skeleton variant="circle" className={classes.skeletonCircle} />
            <Skeleton variant="text" className={classes.skeletonText} />
          </Grid>
        ))}
      </Grid>
      <Grid item className={classes.barContainer}>
        <Skeleton variant="text" className={classes.skeletonBar} />
      </Grid>
      <Grid item className={classes.descriptionContainer}>
        <Skeleton variant="text" className={classes.description} />
        <Skeleton variant="text" className={classes.description} />
        <Skeleton variant="text" className={classes.shortDescription} />
      </Grid>
    </Grid>
  )
}

export default EngagementWidgetSkeleton
